import api from './Api'; // Adjust the path based on your project structure

const BASE_URL = 'voonixAdvertisers/';

export default {
  getAll: () => {
    return api.get(BASE_URL);
  },
  add: (voonixAdvertiser, payer) => {
    const body = {
      voonixAdvertiser,
      payer
    }
    return api.post(BASE_URL, body);
  },
  update: (id, voonixAdvertiser, payer, loginUpdateScope) => {
    const body = {
      voonixAdvertiser,
      payer,
      // 'this' (default, safer) — detach this advertiser onto a new/existing
      // matching SpaceAdvertiserLogin if the current one is shared.
      // 'all' — mutate the shared login in place, affecting siblings.
      ...(loginUpdateScope ? { loginUpdateScope } : {})
    }
    return api.put(`${BASE_URL}${id}`, body);
  },
  getLoginSharing: (id) => {
    return api.get(`${BASE_URL}${id}/login-sharing`);
  },
  updatePostbacksSet: (id, postbackValue) => {
    const body = {
      postbackValue
    }
    return api.put(`${BASE_URL}postbacks/${id}`, body);
  }
};
